import Header from "./Header";
import Sidebar from "./Sidebar";
import rootPage from "../pages/root";
import {usePageTitle} from "@/hooks";
import {createBrowserRouter, Outlet, RouteObject, useRouteError} from "react-router";
import {RouterProvider} from "react-router/dom";
import {createRoutes} from "@/PageDescriptors";
import {ThemeProvider} from "@/context/ThemeProvider";
import Notification from "@/containers/Notification";
import DisabledOnBackendError from "@/containers/DisabledOnBackendError";
import RoleRedirect from "./RoleRedirect";
import Content from "./Content";
import ErrorPage from "@/components/ErrorPage";
import {pathName as errorPagePathName} from "@/errorPageUrl";
import HomeCrumb from "./HomeCrumb";
import ErrorDisplay, {parseErrorReason} from "./ErrorDisplay";
import {PageSidebar} from "./PageSidebar";

function Layout() {
    return (
        <div style={{display: "flex", height: "100%"}}>
            <ThemeProvider>
                <Notification />
                <RoleRedirect>
                    <DisabledOnBackendError>
                        <Header />
                        <Sidebar />
                        <Content>
                            <Outlet />
                        </Content>
                    </DisabledOnBackendError>
                </RoleRedirect>
            </ThemeProvider>
        </div>
    );
}

function ErrorBoundary() {
    const error: any = useRouteError();
    console.error(error);
    return <ErrorDisplay code={error.status || 404} reason={parseErrorReason(error.statusText)} />;
}

const routes: RouteObject[] = [
    {
        children: [
            {
                element: <Layout />,
                children: createRoutes(rootPage),
                handle: {
                    crumb: () => <HomeCrumb />,
                    sidebar: (basepath: string) => <PageSidebar page={rootPage} basePath={basepath} />,
                },
            },
            {
                path: errorPagePathName,
                element: <ErrorPage />,
            },
        ],
        errorElement: <ErrorBoundary />,
    },
];

function MainFrame() {
    usePageTitle();

    const router = createBrowserRouter(routes);

    return <RouterProvider router={router} />;
}

export default MainFrame;
